import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import JobSearch from "./JobSearch";
import Categories from "./Categories";
import TopCategories from "./TopCategories";
import AutoCarousel from "./AutoCarousel";
import JobsList from "./JobsList";
import SolidFutureJobs from "./SolidFutureJobs";
import LatestJobs from "./LatestJobs";
import NewsPaperJobs from "./NewsPaperJobs";
import TrainingCard from "./TrainingCard";
import TrendingAndExpiringJobs from "./TrendingAndExpiringJobs";

export default function Home() {
  const [employers, setEmployers] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    axios
      .get(constvar.api_url + "home/get_employer_carousel", {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setEmployers(res.data.data || []);
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load employer carousel:", error);
        }
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const onScroll = () => setIsScrollVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const [visible, setVisible] = useState(false);

  const carouselItems =
    employers.length > 0
      ? employers
      : Array.from({ length: 8 }, (_, i) => ({
          id: i,
          comp_name: "Company",
          imgUrl: "/default/default_company_logo.jpg",
          clientslug: "#",
        }));

  // var settings = {
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   initialSlide: 0,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         initialSlide: 2
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // };

  return (
    <React.Fragment>
      {/* ── Hero ─────────────────────────────────── */}
      <section className="sf-hero">
        <div className="sf-container">
          <div className="sf-hero-content">
            <div className="sf-hero-badge">
              <i className="ri-check-line" />
              &nbsp;Trusted HR Partner for Jobs, Talent &amp; Career Growth
            </div>
            <h1 className="sf-hero-title">
              Build Your Career.
              <br />
              Hire the Right Talent.
            </h1>
            <p className="sf-hero-subtitle">
              Solid Future HR Consulting connects job seekers with trusted
              employers through smart hiring solutions and career-focused
              opportunities.
            </p>
            <JobSearch />
            <div className="sf-hero-stats">
              <div className="sf-hero-stat">
                <i className="ri-check-line" style={{ color: "#00aeef" }} />
                2500+ Jobs Posted
              </div>
              <div className="sf-hero-stat">
                <i className="ri-check-line" style={{ color: "#00aeef" }} />
                1500+ Job Seekers
              </div>
              <div className="sf-hero-stat">
                <i className="ri-check-line" style={{ color: "#00aeef" }} />
                500+ Companies
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Popular Searches ─────────────────────── */}
      <Categories />
      <div className="home-top-categories">
        <button onClick={() => setVisible(!visible)} className="sf-categories-btn">
          Top Categories  <i className="fa fa-chevron-down" />
        </button>
      </div>  

        {visible && (
          <div className='home-categories-container'>
            <TopCategories />
          </div>
        )}
    {/* <div className="slider-container">
      <Slider {...settings}>
        <div>
          <h3>1</h3>
        </div>
        <div>
          <h3>2</h3>
        </div>
        <div>
          <h3>3</h3>
        </div>
        <div>
          <h3>4</h3>
        </div>
        <div>
          <h3>5</h3>
        </div>
        <div>
          <h3>6</h3>
        </div>
        <div>
          <h3>7</h3>
        </div>
        <div>
          <h3>8</h3>
        </div>
      </Slider>
    </div> */}

      {/* ── Actively Recruiting Employers ────────── */}
      <section className="sf-section sf-section-light">
        <div className="sf-container">
          <AutoCarousel title="Actively Recruiting Employers">
            {carouselItems.map((emp) => (
              <Link
                key={emp.id}
                to={emp.clientslug !== "#" ? `/company/${emp.clientslug}` : "/"}
                className="sf-employer-logo"
              >
                <img src={emp.imgUrl} alt={emp.comp_name} />
              </Link>
            ))}
          </AutoCarousel>
        </div>
      </section>

      {/* ── Hot Jobs ─────────────────────────────── */}
      <div id="sf-hot-jobs">
        <JobsList title="Hot Jobs" size={20} />
      </div>

      {/* ── Solid Future Hiring ──────────────────── */}
      <SolidFutureJobs />
     
      {/* ── Latest Jobs + Blog Sidebar ───────────── */}
      <LatestJobs />

      {/* ── Newspaper Jobs ───────────────────────── */}
      <NewsPaperJobs />

      {/* ── Explore Our Training ─────────────────── */}
      <TrainingCard title="Explore Our Training" />

      {/* ── Trending & Expiring ──────────────────── */}
      <TrendingAndExpiringJobs />

      {/* ── Scroll-to-top ────────────────────────── */}
      {isScrollVisible && (
        <button
          className="sf-scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="fa fa-angle-up" />
        </button>
      )}
    </React.Fragment>
  );
}
